import React from 'react';
import PropTypes from 'prop-types';
import { languageLabel } from './seoOptions';

/**
 * The rows of facility texts, as a table.
 *
 * Shared by the Facility Texts list and the facility detail page, so the two always show the same
 * columns and the same "is it filled in" reading. The detail page passes `onDelete` to get the
 * extra column; the list does not.
 */

const filled = (value) => (
  <span style={{ color: value ? 'green' : 'grey', fontWeight: 'bold' }}>
    {value ? 'Yes' : 'No'}
  </span>
);

const baseColumns = [
  { name: "Facility", label: "Facility", render: (r) => r.facilityName || r.facilityId },
  { name: "Language", label: "Language", render: (r) => r.languageName || languageLabel(r.language) },
  { name: "MetaTitle", label: "SEO Title", render: (r) => r.metaTitle || '-' },
  { name: "MetaDescription", label: "Meta Description", render: (r) => filled(r.metaDescription) },
  { name: "H1Title", label: "H1", render: (r) => r.h1Title || '-' },
  { name: "Description", label: "Facility Text", render: (r) => filled(r.description) },
];

const FacilityTextsTable = ({ rows, onRowClick, onDelete, showFacility }) => {
  const clickable = { cursor: "pointer", color: "#2a6fb0" };
  const columns = showFacility ? baseColumns : baseColumns.filter((c) => c.name !== "Facility");

  return (
    <article className="data-table-wrap">
      <table className="data-lists component-data-table cell-content-align-top">
        <thead>
          <tr>
            {columns.map((property) => (
              <td key={property.name}>{property.label}</td>
            ))}
            {onDelete && <td>&nbsp;</td>}
          </tr>
        </thead>
        {rows.map((row) => (
          <tbody key={row.id}>
            <tr className="hover-listview">
              {columns.map((property) => (
                <td key={property.name} style={clickable} onClick={() => onRowClick(row)}>
                  <strong className="table-cell-label">{property.label}</strong>
                  {property.render(row)}
                </td>
              ))}
              {onDelete && (
                <td>
                  <button type="button" onClick={() => onDelete(row)}>Delete</button>
                </td>
              )}
            </tr>
          </tbody>
        ))}
      </table>
    </article>
  );
};

FacilityTextsTable.defaultProps = {
  showFacility: true,
  onDelete: null
};

FacilityTextsTable.propTypes = {
  rows: PropTypes.array.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  showFacility: PropTypes.bool
};

export default FacilityTextsTable;
